import { t } from "@/i18n";
export const Loader = ({ label = "Loading..." }) => (
  <div data-testid="loader" className="min-h-[50vh] flex flex-col items-center justify-center gap-4 text-slate-500">
    <img src="/logo.png" alt="" className="w-20 h-20 object-contain wobble" />
    <p className="font-bold">{label}</p>
  </div>
);

export const Logo = ({ small }) => (
  <div className="flex items-center gap-2 group" data-testid="brand-logo">
    <img src="/logo.png" alt={t("paintipop")} className={`${small ? "w-11 h-11" : "w-14 h-14"} object-contain -rotate-3 group-hover:rotate-3 transition-transform duration-300`} />
    <span className={`font-display font-bold ${small ? "text-xl" : "text-2xl"} tracking-tight text-[#1E293B]`}>
      {t("painti")}<span className="text-[#FF5252]">{t("pop")}</span>
    </span>
  </div>
);
